import { useCallback, useContext, useRef, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import TabPanel from "../TabPanel";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import BlankCSVMenu from "../RightContextMenu/BlankCSVMenu";
import BlankJSONMenu from "../RightContextMenu/BlankJSONMenu";
import { treeActions } from "../../redux/slices/treeSlice";
import { useEffect } from "react";
import CSVMenu from "../RightContextMenu/CSVMenu";
import TreeLoading from "../Trees/TreeLoading";
import datatypes, { FIELD_TYPE, OTHER_TYPE, RECORD_TYPE } from "../../constants/datatypes";
import OutboundTemplateTree from "../Trees/OutboundTemplateTree";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import ExpandCollapse from "../Search/ExpandCollapse";
import HideMappingButton from '../Mapping/HideMappingButton';
import Delete from "../RightContextMenu/ContextActions/Delete";
import ErrorModal from "../ItemProperties/Forms/FieldDataValidation/ErrorModal";
import OutboundJSONMenu from "../RightContextMenu/OutboundJSONMenu";
import OutboundXMLMenu from "../RightContextMenu/OutboundXMLMenu";
import SearchButton from "../Search/SearchButton";
import { isEqual } from "lodash";
import AiAutoMapping from "../AiAutoMap/AiAutoMapping";
import MappingManager from "../Mapping/MappingManager";
import GraphQLPanel from "./GraphQLPanel";

export default function OutboundTemplatePanel({ setMiddleCurrTab }) {
  const { t } = useTranslation();
  const [currTab, setCurrTab] = useState(1);
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(true);
  // const [headerTrailerActive, setHeaderTrailerActive] = useState(true);
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree, leftTree } = useSelector((state) => state.treeData[parentScreen]);
  const fileType = rightTree?.tree?.templateHeader?.FILETYPE;
  const isGraphQL = fileType === 'GraphQL';
  const [isCopied,setIsCopied] = useState({ copy: false, paste: false })
  const [expandActions,setExpandActions] = useState({tab:'',keys:[]});
  const leftSelectedNode = leftTree.tree.body.selectedNode;
  const templateHeader = rightTree.tree.templateHeader;
  const rightSelectedNode = rightTree.tree[rightTree.currentTab]?.selectedNode || {};
  const isManualTabChange = useRef(false);
  const handleTabChange = (_event, newValue) => {
    const tab = ["header", "body", "trailer"][newValue];
    // Check if this is a manual tab change (not cross-tab navigation)
    const crossTabSourceNodeKey = sessionStorage.getItem('crossTabSourceNodeKey');
    
    
    setCurrTab(newValue, isManualTabChange);
    
    // Only update Redux state if this is a manual tab change
    if (isManualTabChange.current) {
      dispatch(
        treeActions.setRightTreeCurrentTab({
          screen: parentScreen,
          data: ["header", "body", "trailer"][newValue]
        })
      );
    } else {
    }
    
    dispatch(treeActions.setRightTreeSelectedNode({
      screen: parentScreen,
      type: tab,
      data: {}
    }))
    setTimeout(() => {
      let selectedNode = rightTree.tree?.[tab]?.selectedNode;
      selectedNode = selectedNode?.hasOwnProperty("key") ? selectedNode : rightTree?.tree?.[tab]?.translatedData?.[0] || {};
      dispatch(treeActions.setRightTreeSelectedNode({
        screen: parentScreen,
        type: tab,
        data: selectedNode
      }))
    })
    isManualTabChange.current = false;
    };

  useEffect(() => {
    handleTabChange({}, 1);
  }, [rightTree.path]);


  useEffect(() => {
    setDisabled(leftSelectedNode?.type !== 'outboundTemplate');
  }, [leftSelectedNode?.key])

  // Listen to currentMappingTab changes from Redux (only when triggered by node selection)
  const currentMappingTab = useSelector(state => state.treeData.mappingStates.currentMappingTab);
  const lastNodeSelectionTime = useRef(0);
  

  
  // Listen to Redux rightTree.currentTab changes and update local currTab
  useEffect(() => {
    // Get the current tab index from Redux state
    const tabNames = ["header", "body", "trailer"];
    const currentReduxTabIndex = tabNames.indexOf(rightTree?.currentTab);
  
    // Add debugging
  
    // Only block if there's an active cross-tab navigation
    const crossTabSourceNodeKey = sessionStorage.getItem('crossTabSourceNodeKey');
    if (crossTabSourceNodeKey) {
      return;
    }
  
    // Check if tabs are different and update
    if (currentReduxTabIndex !== currTab && currentReduxTabIndex !== -1) {
      setCurrTab(currentReduxTabIndex);
      
      // Clear any stale timestamps
      sessionStorage.removeItem('lastNodeSelectionTime');
    }
  }, [rightTree?.currentTab, currTab]);

  // Monitor Redux state changes for debugging



  // useEffect(() => {
    // Prevent tab change on template header effect. leaving commented for now.
    // setCurrTab(1);
    // const fileType = templateHeader?.FILETYPE;
    // if (fileType) {
      // const showTab =
        // fileType === "DATABASE" ||
        // fileType === "JSON" ||
        // fileType === "XML";
      // setHeaderTrailerActive(true);
      // dispatch(
      //   treeActions.setRightTreeCurrentTab({
      //     screen: parentScreen,
      //     data: "body"
      //   })
      // );
    // } else {
      // setHeaderTrailerActive(false);
    // }
  // }, [templateHeader])

  const handleKeyDown = useCallback((event)=>{
    if (event.ctrlKey && rightSelectedNode) {
      if (event.key === "c" || event.key === "C") {
        setIsCopied({...isCopied, paste: false, copy: true,treeType:parentScreen });
      } else if (event.key === "v" || event.key === "V") {
        setIsCopied({ ...isCopied,paste:true,dispatchFrom:'keyPress',treeType:parentScreen});
      }
    } 
  },[isCopied, rightSelectedNode, parentScreen]);

  useEffect(() => {
    document?.getElementById("ob-tree")?.focus()
  },[currTab])

  let contextMenuOptions = [];
  if (templateHeader?.FILETYPE === 'XML') {
    //xml body has element/attribute, but header/trailer uses record/field.
    if (currTab !== 1) {
      contextMenuOptions = [
        <BlankCSVMenu key="ctx1" isCopied={isCopied} setIsCopied={setIsCopied} targetId={"rightTreeOutbound"} />,
        <CSVMenu key="ctx2" isCopied={isCopied} setIsCopied={setIsCopied} targetId={"rightTreeOutbound"} />
      ];
    } else {
      contextMenuOptions = [
        <OutboundXMLMenu key="ctx1" isCopied={isCopied} setIsCopied={setIsCopied} targetId={"rightTreeOutbound"}/>
      ];
    }
  } else if (templateHeader?.FILETYPE === 'JSON') {
    //json ctx menu uses Object records.
    contextMenuOptions = [
      <BlankCSVMenu key="ctx1" isCopied={isCopied} setIsCopied={setIsCopied} targetId={"rightTreeOutbound"} obJSON={true}/>,
      <OutboundJSONMenu key="ctx2" isCopied={isCopied} setIsCopied={setIsCopied} targetId={"rightTreeOutbound"} />
    ];
  } else {
    //csv, etx ctx menu uses record/field.
    contextMenuOptions = [
      <BlankCSVMenu key="ctx1" isCopied={isCopied} setIsCopied={setIsCopied} targetId={"rightTreeOutbound"} />,
      <CSVMenu key="ctx2" isCopied={isCopied} setIsCopied={setIsCopied} targetId={"rightTreeOutbound"} />
    ];
  }

  //primitive check for no data panel for now. adding because xml behaves different from other datatypes, and need to conditionally render for each tab.
  let noDataHeader = false;
  let noDataTrailer = false;
  const tDataH = rightTree?.tree?.header?.translatedData;
  const tDataT = rightTree?.tree?.trailer?.translatedData;

  if (tDataH?.length === 0) noDataHeader = true;
  if (tDataT?.length === 0) noDataTrailer = true;

  if (fileType === "XML") {
    //for xml, dont show the ghost nodes in header/trailer.
    if (tDataH?.[0]?.ICON_DISPLAY === "REPEATING_ELEMENT" && !tDataH?.[0]?.DESCRIPTION) noDataHeader = true;
    if (tDataT?.[0]?.ICON_DISPLAY === "REPEATING_ELEMENT" && !tDataT?.[0]?.DESCRIPTION) noDataTrailer = true;
  }

  return (
    <div
      id="ob-tree"
      onKeyDown={(e)=>{
        if (document?.activeElement?.id !== "ob-tree") return;
        handleKeyDown(e,isCopied)
      }} 
      tabIndex={0} 
      className="flex-column height-100"
    >
      <Box>
        {!isGraphQL && (
        <div
          className="flex justify-end"
          style={{
            position: "fixed",
            right: "0",
            height: "32px",
            padding: "0",
            zIndex: "20",
            marginTop: "-2px",
            backgroundColor: "white",
            borderLeft: "1px solid #e0e0e0",
            // paddingLeft: "8px"
          }}
        >
          {/* <MappingManager /> */}
          <HideMappingButton side="target" />
          <AiAutoMapping />
          <SearchButton setExpandActions={setExpandActions} />
          <ExpandCollapse setExpandActions={setExpandActions} />
        </div>
        )}
      </Box>
       {isGraphQL && (
          <div>
            <GraphQLPanel />
          </div>
        )}
      {!isGraphQL && (
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={currTab} onChange={(e, newValue) => {
            isManualTabChange.current = true;
            handleTabChange(e, newValue);
          }}>
            <Tab disabled={disabled} label={t("HEADER")} sx={{fontSize: "12px !important", minWidth: "60px !important"}}/>
            <Tab disabled={disabled} label={t("BODY")} sx={{fontSize: "12px !important", minWidth: "60px !important"}}/>
            <Tab disabled={disabled} label={t("TRAILER")} sx={{fontSize: "12px !important", minWidth: "60px !important"}}/>
          </Tabs>
        </Box>
      )}
      <Box sx={{flex: "1", overflow: "auto"}}  id="rightTreeOutbound">
        {/* header */}
        {!isGraphQL && (
          <TabPanel value={currTab} index={0} className="height-100">
            <div className="height-100 overflow-auto">
              <OutboundTemplateTree expandActions={expandActions} tab="header" setMiddleCurrTab={setMiddleCurrTab} />
            </div>
          </TabPanel>
        )}

        {/* body */}
        <TabPanel value={currTab} index={1} className={"height-100"}>
          <div className="height-100 overflow-auto">
            {
              // rightTree.tree.body.translatedData?.length > 0 ?
                
                rightTree.loading ? <TreeLoading />
                  : rightTree.fetchError ? <div className="panel-fetch-error">{t('ERROR_FETCHING_TEMPLATE')}</div>
                    : <OutboundTemplateTree expandActions={expandActions} tab="body" setMiddleCurrTab={setMiddleCurrTab} />
            }
          </div>
        </TabPanel>

        {/* trailer */}
        {/* OverFlowing Trailer Section, So added Class */}
        {!isGraphQL && (
          <TabPanel className={"height-100"} value={currTab} index={2}>
            <div className="height-100 overflow-auto">
              <OutboundTemplateTree expandActions={expandActions} tab="trailer" setMiddleCurrTab={setMiddleCurrTab} />
            </div>
          </TabPanel>
        )}
        {!isGraphQL && contextMenuOptions}
        {/* {(currTab === 1 || headerTrailerActive) && templateHeader.FILETYPE !== 'XML' && <BlankCSVMenu isCopied={isCopied} setIsCopied={setIsCopied} targetId={"rightTreeOutbound"} />}
        {(currTab === 1 || headerTrailerActive) && templateHeader.FILETYPE !== 'XML' && <CSVMenu isCopied={isCopied} setIsCopied={setIsCopied} targetId={"rightTreeOutbound"} />}
        {templateHeader?.FILETYPE === 'JSON' && (currTab === 1 || headerTrailerActive) && <OutboundJSONMenu isCopied={isCopied} setIsCopied={setIsCopied} targetId={"rightTreeOutbound"} />}
        {templateHeader?.FILETYPE === 'XML' && (currTab ===1 || headerTrailerActive) && <OutboundXMLMenu isCopied={isCopied} setIsCopied={setIsCopied} targetId={"rightTreeOutbound"}/>} */}
      </Box>
    </div>
  );
}
